'use client';

import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { subscribeToNewsletter } from '@/app/actions/newsletter';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export function InsightNewsletterBox() {
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setIsSubmitting(true);
    const formData = new FormData(e.currentTarget);
    const result = await subscribeToNewsletter(formData);
    
    if (result.success) {
      toast.success(result.message);
      (e.target as HTMLFormElement).reset();
    } else {
      toast.error(result.error || 'Failed to subscribe');
    }
    setIsSubmitting(false);
  }

  return (
    <div className="glass-card rounded-2xl p-6 space-y-4">
      <h2 className="text-sm font-black text-foreground">Subscribe to AI Digest</h2>
      <p className="text-[10px] text-muted-foreground font-medium">
        Get the latest platform updates and merger news delivered to your inbox weekly.
      </p>
      <form onSubmit={handleSubmit} className="flex gap-2">
        <label htmlFor="insight-newsletter-email" className="sr-only">
          Email address
        </label>
        <Input 
          id="insight-newsletter-email"
          name="email"
          type="email" 
          required
          placeholder="Email address"
          className="h-9 flex-1 text-xs" 
        />
        <Button 
          type="submit" 
          disabled={isSubmitting}
          className="h-9 rounded-lg bg-primary px-3 py-2 text-[10px] font-black uppercase text-primary-foreground transition-all hover:bg-primary/90"
        >
          {isSubmitting ? <Loader2 className="h-3 w-3 animate-spin" /> : 'Join'}
        </Button>
      </form>
    </div>
  );
}
